import { css } from '@emotion/css'
import type { TLanguage } from '@semios/app-platform-i18n-core'
import type { TOptions } from 'components/MultiSelect/MultiSelect.types'
import { colors } from 'settings/colors'

export type GroupFormType = {
  name: string
  contacts: TOptions[]
}

export type ContactFormType = {
  name: string
  email: string | null
  sms: string | null
  groups: TOptions[]
  language: TLanguage
}

export const invalidInputClassName = css({ borderColor: colors.red })
